//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';


class API {
  async configure(){
    // await localforage.defineDriver(memoryDriver);

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: 'infohidro-alerts'
    });

    const cache = setupCache({
      // {Number} Maximum time for storing each request in milliseconds,
      // defaults to 15 minutes when using `setup()`.
      maxAge: 24 * 60 * 60 * 1000, // 24 hour
      // {Number} Maximum number of cached request (last in, first out queue system),
      // defaults to `false` for no limit. *Cannot be overridden per request*
      limit: 20,
      store: forageStore
    });
    
    
    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_ALERT}`
    });

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }
}

export default API;